<div class="title-bar d-flex justify-content-between align-items-center">
  <div fxLayout="row" fxLayoutAlign="start center">
    <button
      mat-button
      class="appear-horizontal me-3"
      type="button"
      (click)="onCancel()"
    >
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h1>
      <ng-container *ngIf="readOnly; else editTitle">
        {{ "PRODUCTS.VIEW_ONLY.TITLE" | translate }}
      </ng-container>
      <ng-template #editTitle>
        <ng-container *ngIf="isCreateMode; else editModeTitle">
          {{ "PRODUCTS.CREATE.TITLE" | translate }}
        </ng-container>
        <ng-template #editModeTitle>
          {{ "PRODUCTS.EDIT.TITLE" | translate }}
        </ng-template>
      </ng-template>
    </h1>
  </div>
  <a
    *ngIf="isAdminMode && readOnly"
    mat-stroked-button
    color="primary"
    class="title-button"
    [routerLink]="['/admin/approvals/products/edit']"
    [queryParams]="{ id: productId }"
    [routerLinkActive]="'active'"
  >
    <mat-icon>edit</mat-icon>
    {{ "SHARED.EDIT" | translate }}
  </a>
</div>
<app-data-sheet-tabs
  [queryParams]="{ id: productId, userType: userType }"
  [showOnlyFirstTab]="onlyFirstTab"
  [showCollectionsTab]="true"
  [tabPanel]="tabPanel"
></app-data-sheet-tabs>
<mat-tab-nav-panel #tabPanel>
  <router-outlet></router-outlet>
</mat-tab-nav-panel>
